(function () {
  function init(root) {
    if (!root || root.dataset.pwRivageReady === 'true') return;
    root.dataset.pwRivageReady = 'true';

    var items = root.querySelectorAll('[data-pw-rivage-reveal]');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    root.classList.add('pw-rivage--motion');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    items.forEach(function (item) { observer.observe(item); });
  }

  function boot() { document.querySelectorAll('[data-pw-rivage]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-pw-rivage]'));
  });
})();
